import React from 'react';
import { XIcon } from './icons/XIcon';

interface InfoModalProps {
    title: string;
    children: React.ReactNode;
    onClose: () => void;
}

const InfoModal: React.FC<InfoModalProps> = ({ title, children, onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col">
                <div className="flex justify-between items-center p-4 border-b">
                    <h3 className="text-xl font-bold text-gray-900">{title}</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-700"><XIcon className="w-6 h-6" /></button>
                </div>
                <div className="p-6 overflow-y-auto">
                    {children}
                </div>
                <div className="p-4 border-t bg-gray-50 rounded-b-2xl text-right">
                    <button onClick={onClose} className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded-lg">Close</button>
                </div>
            </div>
        </div>
    );
};

export default InfoModal;
